import { Component, OnInit, Input, Output, ViewChildren, QueryList, EventEmitter } from '@angular/core';
import { DOData, NJDocData, NJDocDefTemplate, componentVM } from '../DOData';
import { DocDefPrimLibService } from '../../doc-def-prim-lib.service';

import { DOTextBoxComponent } from '../dotext-box/dotext-box.component';
import { DodropDownComponent } from '../dodrop-down/dodrop-down.component';
import { DotextBoxAutocompleteComponent } from '../dotext-box-autocomplete/dotext-box-autocomplete.component';
import { DropdownAutoCompleteComponent } from '../dodropdown-autocomplete/dropdown-autocomplete.component';
import { GridNCheckboxComponent } from '../grid-ncheckbox/grid-ncheckbox.component';
import { GridNRadioButtonComponent } from '../grid-nradiobutton/grid-nradiobutton.component';
import { GridInternalComponent } from '../grid-internal/grid-internal.component'
import { DoimageComponent } from '../doimage/doimage.component';
import { IServerSideGetRowsParams } from 'ag-grid-community';
import { DobuttonComponent } from '../dobutton/dobutton.component';
import { GridInternalAgGridComponent } from '../grid-internal-ag-grid/grid-internal-ag-grid.component';
import { DOLabelComponent } from '../dolabel/dolabel.component';
import { DotextBoxSglComponent } from '../dotext-box-sgl/dotext-box-sgl.component';
import { DoDateNgComponent } from '../do-date-ng/do-date-ng.component';
import { DropdownCommentsComponent } from '../dropdown-comments/dropdown-comments.component' ;
import { GridInternalAgGridClComponent } from '../grid-internal-ag-grid/grid-internal-ag-grid-cl.component';
import { PreviousAnswerButtonComponent } from '../previous-answer-button/previous-answer-button.component';


@Component({
    selector: 'cy-section-table',
    templateUrl: './section-table.component.html',
    styleUrls: ['./section-table.component.css']
})
export class SectionTableComponent implements OnInit {
    rowStyle: any;

    constructor(private data: DocDefPrimLibService) { }
    private maxCol = -1;
    private maxRow = -1;
    public rowNumbers: Array<String> = new Array<String>();
    private _tableVM: Array<DOData>;
    public sectionClass: string;
    public sectionStyle: string;
    @Input() public cutoffDate: string = "";
    @Input() public ignorLabel: boolean = false;
    @Input() public loaderKey: string;
    @Input() public parentLoaderKey: string = "";
    @Input() public set tableVM(TableVM: Array<DOData>) {
        this._tableVM = TableVM;
    }
    @Input() public skipTBPostDocDefData: boolean = false;
    @Input() public skipDDLPostDocDefData: boolean = false;
    @Input() public skipDatePostDocDefData: boolean = false;
    @Input() public skipTBSglPostDocDefData: boolean = false;
    @Input() public skipGridCBPostDocDefData: boolean = false;
    @Input() public skipGridRadioPostDocDefData: boolean = false;
    @Input() public skipAutoDDLPostDocDefData: boolean = false;
    @Input() public skipAutoDDCPostDocDefData: boolean = false;
    @Input() public skipNRBPostDocDefData: boolean = false;
    @Input() public skipAGGridCBPostDocDefData: boolean = false;

    public get tableVM(): Array<DOData> {
        return this._tableVM;
    }
    public ToTdClassWid: object = {};
    public ToTdClassWidSM: object = {};
    public ToTdClassWidXS: object = {};
    public ToTdClass: object = {};
    public rowClass: string = "";
    private cellClass: string = "";
    public cellStyle: string = "";
    public curRow: Array<Array<DOData>>;

    @Output() editItem: EventEmitter<Array<DOData>> =
        new EventEmitter<Array<DOData>>();
    @Output() clickBut: EventEmitter<DOData> =
        new EventEmitter<DOData>();
    @Output() clickPrevBut: EventEmitter<DOData> =
        new EventEmitter<DOData>();
    @Output() clickEventStart: EventEmitter<DOData> =
        new EventEmitter<DOData>();
    @Output() gridReady: EventEmitter<DOData> =
        new EventEmitter<DOData>();
    @Output() clickChkbox: EventEmitter<DOData> =
        new EventEmitter<DOData>();
    @Output() clickRadio: EventEmitter<DOData> =
        new EventEmitter<DOData>();
    @Output() gridDoubleClick: EventEmitter<DOData> =
        new EventEmitter<DOData>();
    @Output() cellClicked: EventEmitter<DOData> =
        new EventEmitter<DOData>();
    @Output() tabEvent: EventEmitter<componentVM> =
        new EventEmitter<componentVM>();

    @Output() requestRows: EventEmitter<boolean> =
        new EventEmitter<boolean>();
    @Output() section_tableAfterViewInit: EventEmitter<SectionTableComponent> =
        new EventEmitter<SectionTableComponent>();
    @Output() retDocUploadRes: EventEmitter<Array<NJDocData>> =
        new EventEmitter<Array<NJDocData>>();

    @Output() section_tableAfterViewChecked: EventEmitter<SectionTableComponent> =
        new EventEmitter<SectionTableComponent>();
    @Output() rowDataSelected: EventEmitter<any> = new EventEmitter();
    @ViewChildren(DOLabelComponent) DOLabelComponents: QueryList<DOLabelComponent>;
    @ViewChildren(DOTextBoxComponent) TextBoxComponents: QueryList<DOTextBoxComponent>;
    @ViewChildren(DotextBoxSglComponent) TextBoxSglComponents: QueryList<DotextBoxSglComponent>;
    @ViewChildren(DoDateNgComponent) DateNgComponents: QueryList<DoDateNgComponent>;
    @ViewChildren(DodropDownComponent) DropDownsComponents: QueryList<DodropDownComponent>;
    @ViewChildren(GridNCheckboxComponent) GridNCheckboxComponents: QueryList<GridNCheckboxComponent>;
    @ViewChildren(DotextBoxAutocompleteComponent) DotextBoxAutocompleteComponents: QueryList<DotextBoxAutocompleteComponent>;
    @ViewChildren(DropdownAutoCompleteComponent) DropdownAutoCompleteComponents: QueryList<DropdownAutoCompleteComponent>;
    @ViewChildren(GridNRadioButtonComponent) GridNRadioButtonComponents: QueryList<GridNRadioButtonComponent>;
    @ViewChildren(GridInternalComponent) GridInternalComponents: QueryList<GridInternalComponent>;
    @ViewChildren(DobuttonComponent) DobuttonComponents: QueryList<DobuttonComponent>;
    @ViewChildren(PreviousAnswerButtonComponent) PreviousAnswerButtonComponents: QueryList<PreviousAnswerButtonComponent>;
    @ViewChildren(GridInternalAgGridComponent) GridInternalAgGridComponents: QueryList<GridInternalAgGridComponent>;
    @ViewChildren(DropdownCommentsComponent) DropdownCommentsComponents: QueryList<DropdownCommentsComponent>;
    @ViewChildren(GridInternalAgGridClComponent) GridInternalAgGridClComponent: QueryList<GridInternalAgGridClComponent>;
    //
    getScrRowParam(customParameters: any): string {
        if (customParameters['row'] == null)
            if (customParameters['scrRow'] == null)
                return null;
            else
                return customParameters['scrRow'];
        else
            return customParameters['row']
    }
    ngOnInit() {
        //----------------------------------------------------------------------------
        this.maxCol = -1;
        let max = this.maxCol;
        this._tableVM.forEach(function (d: DOData) {
            if (d.customParameters['col'] == null) {
            } else {
                let item = +d.customParameters['col'];
                if (max < item)
                    max = item;
            }
        });
        this.maxCol = max;
        //--------------
        this.maxRow = -1;
        let maxRow = this.maxRow;
        let _this = this;
        this._tableVM.forEach(function (d: DOData) {
            if (_this.getScrRowParam(d.customParameters) == null) {
            } else {
                if (_this.rowNumbers.indexOf(_this.getScrRowParam(d.customParameters))==-1)
                    _this.rowNumbers.push(_this.getScrRowParam(d.customParameters));
                let item = +_this.getScrRowParam(d.customParameters);
                if (maxRow < item)
                    maxRow = item;
            }
        });

        _this.rowNumbers.sort(function (a, b) { return (+a) - (+b) });
        this.maxRow = maxRow;
        //----------------------------------------------------------------------------
        if (this.tableVM[0].customParameters['Class'] == null) {
            this.sectionClass = "";
        } else {
            this.sectionClass = this.tableVM[0].customParameters['Class'];
        }
        if (this.tableVM[0].customParameters['sectionStyle'] == null) {
            this.sectionStyle = "";
        } else {
            this.sectionStyle = this.tableVM[0].customParameters['sectionStyle'];
        }
        if (this.tableVM[0].customParameters['ToTdClassWid'] != null) {
            let styles = this.data.replaceAll(this.tableVM[0].customParameters['ToTdClassWid'], "'", '"');
            this.ToTdClassWid = JSON.parse(styles);
        }
        if (this.tableVM[0].customParameters['ToTdClass'] != null) {
            let styles = this.data.replaceAll(this.tableVM[0].customParameters['ToTdClass'], "'", '"');
            this.ToTdClass = JSON.parse(styles);
        }
        if (this.tableVM[0].customParameters['ToTdClassWidSM'] != null) {
            let styles = this.data.replaceAll(this.tableVM[0].customParameters['ToTdClassWidSM'], "'", '"');
            this.ToTdClassWidSM = JSON.parse(styles);
        }
        if (this.tableVM[0].customParameters['ToTdClassWidXS'] != null) {
            let styles = this.data.replaceAll(this.tableVM[0].customParameters['ToTdClassWidXS'], "'", '"');
            this.ToTdClassWidXS = JSON.parse(styles);
        }
        if (this.tableVM[0].customParameters['rowClass'] != null) {
            this.rowClass = this.tableVM[0].customParameters['rowClass'];
        }
        if (this.tableVM[0].customParameters['rowStyle'] != null) {
            this.rowStyle = this.tableVM[0].customParameters['rowStyle'];
        }
        if (this.tableVM[0].customParameters['CellClass'] != null) {
            this.cellClass = this.tableVM[0].customParameters['CellClass'];
        }
        if (this.tableVM[0].customParameters['cellStyle'] != null) {
            let styles = this.data.replaceAll(this.tableVM[0].customParameters['cellStyle'], "'", '"');
            this.cellStyle = JSON.parse(styles);
        }        
    }
    ngOnChanges(): void {
    }
    hasToStyle() {
        // count objects in ToTdClassWid. 
        return Object.keys(this.ToTdClassWid).length >= this.maxCol;
    }
    getWidth(item: DOData): string {
        let ret: string = "";
        if (item.customParameters['CellClass'] == null) {
            ret = "";
        } else {
            ret = item.customParameters['CellClass'];
        }
        return this.cellClass + " " + ret;
    }
    getFormClass(item: DOData): string {
        let ret: string = "";
        if (item.customParameters['FormInline'] != null) {
            ret = item.customParameters['FormInline'];
        } else {
            if (item.customParameters['FormGroup'] != null) {
                ret = item.customParameters['FormGroup'];
            } else {
                ret = "";
            }
        }
        return ret;
    }
    //purpose: to add together col classes given comlumn span 
    // e.g.: col-sm-colSum
    getCols2End(col: number, span: number, colWidClass: object): string {
        let colSum: number = 0;
        let strRet: string = "";
        let col1: number = col;
        for (; col1 <= Object.keys(colWidClass).length; col1++) {
            if (span > 0) {
                span--;
                let str = colWidClass["width" + col1];
                var matches = str.match(/\d+$/);
                strRet = str.substring(0, str.length - matches[0].length)
                colSum = colSum + (+matches[0]);
            }
        }
        return strRet + colSum;
    }

    //getColSpan(item: DOData): number {
    //    if (item.customParameters['Colspan'] == null) {
    //        return 1;
    //    } else {
    //        return +item.customParameters['Colspan'];
    //    }
    //}
    //getRowSpan(item: DOData): number {
    //    if (item.customParameters['Rowspan'] == null) {
    //        return null;
    //    } else {
    //        return +item.customParameters['Rowspan'];
    //    }
    //}
    public getTableVM_byCol(col: string): Array<DOData> {
        return this.performFilter(col);
    }
    public getFlexClass(item: DOData,i:number): string {
        //the Flex class is used for more than one object in a cell
        // when that happens the class is read from the DOData and used to adjust the width of each object in the cell
        if (this.curRow[i].length > 1) {
            if (item.customParameters['InputWidth'] == null) {
                return "";
            } else {
                return item.customParameters['InputWidth'];
            }
        }else return "";
    }
    performFilter(col: string): Array<DOData> {
        let test = this.tableVM;
        return this.tableVM.filter((d: DOData) => {
            if (d.customParameters['col'] == null) {
                return false;
            } else {
                return d.customParameters['col'] == col;
            }
        })
    }
    // return first item of each cell. Usually the only one, except if multiple obects per cell.
    public getTableVM_byRow(row: string): Array<DOData> {
        let retLst = this.performFilterRow(row);
        let ret: Array<DOData> = new Array<DOData>();
        this.curRow = new Array<Array<DOData>>();
        let i: number = 0;
        this.curRow.push(new Array<DOData>());
        let lastDOData = retLst[0];
        ret.push(lastDOData); // add first column to return: first item of each cell
        for (let item of retLst) {
            if (item.customParameters['col'] == lastDOData.customParameters['col'])
                this.curRow[i].push(item);
            else {
                i++;
                this.curRow.push(new Array<DOData>());
                this.curRow[i].push(item);
                ret.push(item); // add next column to return: first item of each cell
            }
            lastDOData = item;
        }
        //console.log(ret);
        //if (!ret[0]) {
        //    debugger;
        //}
        return ret;
    }
    getlstInCell(arrIndex: number):Array<DOData>  {
        return this.curRow[arrIndex];
    }
    performFilterRow(row: string): Array<DOData> {
        let test = this.tableVM;
        return this.tableVM.filter((d: DOData) => {
            if (this.getScrRowParam(d.customParameters) == null) {
                return false;
            } else {
                return this.getScrRowParam(d.customParameters) == row;
            }
        })
    }
    getTableVM_cols(): string[] {
        var i
        let ret: string[] = [];
        for (i = 1; i <= this.maxCol; i++) {
            ret.push(i.toString())
        }
        return ret;
    }
    // After init get data from child table, so that the parent can use it to execute requests. 
    // Example: Get address fields and open google map in another tab on browser. See onClickButton in demographics.component.ts
    ngAfterViewInit() {     
        this.section_tableAfterViewInit.emit(this);
    }

    ngAfterViewChecked() {
        this.section_tableAfterViewChecked.emit(this);
    }
    public getPrimitives(): Array<DOData> {
        let lstDoData: Array<DOData> = new Array<DOData>();
        this.TextBoxComponents.forEach((TextBox: DOTextBoxComponent) => {
            let DoDOData: DOData = new DOData();
            DoDOData.njDocData = TextBox.DocData;
            DoDOData.customParameters = TextBox.customParameters;
            DoDOData.njDocDefTemplate = TextBox.DocDefTemplate;
            lstDoData.push(DoDOData);
        });
        this.TextBoxSglComponents.forEach((TextBox: DotextBoxSglComponent) => {
            let DoDOData: DOData = new DOData();
            DoDOData.njDocData = TextBox.DocData;
            DoDOData.customParameters = TextBox.customParameters;
            DoDOData.njDocDefTemplate = TextBox.DocDefTemplate;
            DoDOData.isEnabled = TextBox.isEnabled;
            lstDoData.push(DoDOData);
        });
        this.DOLabelComponents.forEach((Label: DOLabelComponent) => {
            let DoDOData: DOData = new DOData();
            DoDOData.customParameters = Label.customParameters;
            DoDOData.njDocDefTemplate = Label.DocDefTemplate;
            lstDoData.push(DoDOData);
        });
        this.DropDownsComponents.forEach((DropDown: DodropDownComponent) => {
            let DoDOData: DOData = new DOData();
            DoDOData.njDocData = DropDown.DocData;
            DoDOData.lstDocDefTemplateLookup = DropDown.lstDocDefTemplateLookup;
            DoDOData.customParameters = DropDown.customParameters;
            DoDOData.njDocDefTemplate = DropDown.DocDefTemplate;
            lstDoData.push(DoDOData);
        });
        this.GridNRadioButtonComponents.forEach((GridNRadio: GridNRadioButtonComponent) => {
            let DoDOData: DOData = new DOData();
            DoDOData.njDocData = GridNRadio.DocData;
            DoDOData.lstDocDefTemplateLookup = GridNRadio.lstDocDefTemplateLookup;
            DoDOData.customParameters = GridNRadio.customParameters;
            DoDOData.njDocDefTemplate = GridNRadio.DocDefTemplate;
            lstDoData.push(DoDOData);
        });
        this.GridNCheckboxComponents.forEach((GridNCheckbox: GridNCheckboxComponent) => {
            let DoDOData: DOData = new DOData();
            DoDOData.lstDocData = GridNCheckbox.lstDocData;
            DoDOData.lstChildDocDefTemplate = GridNCheckbox.lstChildDocDefTemplate;
            DoDOData.customParameters = GridNCheckbox.customParameters;
            DoDOData.njDocDefTemplate = GridNCheckbox.DocDefTemplate;
            lstDoData.push(DoDOData);
        });
        this.DotextBoxAutocompleteComponents.forEach((TextBox: DotextBoxAutocompleteComponent) => {
            let DoDOData: DOData = new DOData();
            DoDOData.njDocData = TextBox.DocData;
            DoDOData.customParameters = TextBox.customParameters;
            DoDOData.njDocDefTemplate = TextBox.DocDefTemplate;
            lstDoData.push(DoDOData);
        });
        this.DropdownAutoCompleteComponents.forEach((DropDownAutoComplete: DropdownAutoCompleteComponent) => {
            let DoDOData: DOData = new DOData();
            DoDOData.njDocData = DropDownAutoComplete.DocData;
            DoDOData.lstDocData = DropDownAutoComplete.lstDocData;
            DoDOData.customParameters = DropDownAutoComplete.customParameters;
            DoDOData.njDocDefTemplate = DropDownAutoComplete.DocDefTemplate;
            DoDOData.lstChildDocDefTemplate = DropDownAutoComplete.lstChildDocDefTemplate;
            DoDOData.lstDocDefTemplateLookup = DropDownAutoComplete.lstDocDefTemplateLookup;
            lstDoData.push(DoDOData);
        });
        this.DateNgComponents.forEach((Date: DoDateNgComponent) => {
            let DoDOData: DOData = new DOData();
            DoDOData.njDocData = Date.DocData;
            DoDOData.customParameters = Date.customParameters;
            DoDOData.njDocDefTemplate = Date.DocDefTemplate;
            lstDoData.push(DoDOData);
        });
        this.DateNgComponents.forEach((Date: DoDateNgComponent) => {
            let DoDOData: DOData = new DOData();
            DoDOData.njDocData = Date.DocData;
            DoDOData.customParameters = Date.customParameters;
            DoDOData.njDocDefTemplate = Date.DocDefTemplate;
            lstDoData.push(DoDOData);
        });
        this.DobuttonComponents.forEach((Buttons: DobuttonComponent) => {
            let DoDOData: DOData = new DOData();
            DoDOData.njDocData = Buttons.DocData;
            DoDOData.customParameters = Buttons.customParameters;
            DoDOData.njDocDefTemplate = Buttons.DocDefTemplate;
            DoDOData.isEnabled = Buttons.isEnabled;
            lstDoData.push(DoDOData);
        });
        this.PreviousAnswerButtonComponents.forEach((Buttons: PreviousAnswerButtonComponent) => {
            let DoDOData: DOData = new DOData();
            DoDOData.njDocData = Buttons.DocData;
            DoDOData.customParameters = Buttons.customParameters;
            DoDOData.njDocDefTemplate = Buttons.DocDefTemplate;
            DoDOData.isEnabled = Buttons.isEnabled;
            lstDoData.push(DoDOData);
        });
        

        return lstDoData;
    }
    //getButtons(lstChildDocDefTemplate: Array<NJDocDefTemplate>): Array<NJDocDefTemplate> {
    //    let ret: Array<NJDocDefTemplate> = new Array<NJDocDefTemplate>();
    //    for (var i: number = 0; i < lstChildDocDefTemplate.length; i++) {
    //        if (lstChildDocDefTemplate[i].dictCustomParameters['isGridColumn'] == "False")
    //            ret.push(lstChildDocDefTemplate[i]);
    //    }
    //    return ret
    //}
    enableButton(templaceCode: string, state: boolean) {
        this.DobuttonComponents.forEach((button: DobuttonComponent) => {
            if (button.DocDefTemplate.templateCode == templaceCode)
                button.isEnabled = state;
        });
        this.PreviousAnswerButtonComponents.forEach((button: PreviousAnswerButtonComponent) => {
            if (button.DocDefTemplate.templateCode == templaceCode)
                button.isEnabled = state;
        });
        
    }
    resetDropdown(templateId: number) {
        this.DropDownsComponents.forEach((dropdown: DodropDownComponent) => {
            if (dropdown.DocDefTemplate.docDefTemplateID == templateId)
                dropdown.resetSelection();
        });
    }
    clearTextbox(templateId: number) {
        this.TextBoxComponents.forEach((textbox: DOTextBoxComponent) => {
            if (textbox.DocDefTemplate.docDefTemplateID == templateId)
                textbox.clearTextbox();
        });
    }
    setTextInTextbox(templateId: number, value: string) {
        this.TextBoxComponents.forEach((textbox: DOTextBoxComponent) => {
            if (textbox.DocDefTemplate.docDefTemplateID == templateId)
                textbox.setTextToValue(value);
        });
    }

    clearDropdowns() {
        this.DropDownsComponents.forEach((dropdown: DodropDownComponent) => {
                dropdown.resetSelection();
        });
    }
    clearTextboxes() {
        this.TextBoxComponents.forEach((textbox: DOTextBoxComponent) => {
            textbox.clearTextbox();
        });
    }
    clearSglTextboxes() {
        this.TextBoxSglComponents.forEach((textbox: DotextBoxSglComponent) => {
            textbox.clearTextbox();
        });
    }
    clearGridNCheckboxes() {
        this.GridNCheckboxComponents.forEach((GridNCheckbox: GridNCheckboxComponent) => {
            GridNCheckbox.clearCheckBoxes();
        });
    }


    onGridClickBut(message: DOData, but: NJDocDefTemplate) {
        message.njDocDefTemplate = but;
        this.clickBut.emit(message);
    }
    onclickBut(message: DOData) {
        this.clickBut.emit(message);
    }
    onclickPrevBut(message: DOData) {
        this.clickPrevBut.emit(message);
    }
    onclickEventStart(message: DOData) {
        this.clickEventStart.emit(message);
    }
    onGridReady(message: DOData) {
        this.gridReady.emit(message);
    }
    onclickChkbox(message: DOData) {
        this.clickChkbox.emit(message);
    }
    onDoubleClickGrid(message: DOData) {
        this.gridDoubleClick.emit(message);
    }
    onCellClicked(message: DOData) {
        this.cellClicked.emit(message);
    }
    onTabEvent(message: componentVM) {
        this.tabEvent.emit(message);
    }
    selectedRowData(data: any) {
        this.rowDataSelected.emit(data);
    }
    public editCurItem(message: Array<DOData>) {
        this.editItem.emit(message);
    }
    onclickRadio(message: DOData) {
        this.clickRadio.emit(message);
    }
    onRequestRows(message: boolean) {
        this.requestRows.emit(message);
    }
    stDocUploadResult(res: Array<NJDocData>)
    {
        this.retDocUploadRes.emit(res);
    }
}
